<template>
  <v-dialog v-if="dialog"  v-model="dialog" :max-width="options.width" @keydown.esc="cancel()">
    <v-toolbar dark :color="options.color" dense>
      <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card tile>
      <v-card-text >
        <div style="color: red;" v-if="errorPresent">
        <h3 >
          There was an error in one or more of the credentials you previously provided. Please correct this information.
        </h3>
        <ul class="a">
        <li class="elist" v-if="err_state"> State License was incorrect. </li>
        <li class="elist" v-if="err_metrc"> METRC API Key was incorrect. </li>
        </ul>
        </div>
        <p>
        Cortex needs your METRC API Key as well as your state license number in order to retrieve and update your data.
        </p>
        <h3>Steps to generate or update an API key in METRC</h3>
        <ul class="a">
          <li>Select your user profile > API Keys.</li>
          <li>Select Generate</li>
          <img src="../assets/api_key_generate.png" />
          <li>Copy the entire API key from the Current API Key field.</li>
          <li>Enter the API Key as well as your State License Number for the facility in the form below and save.</li>
        </ul>
        <p/>
        <p>
        By default, Cortex will sync all of your active strains, rooms and items from METRC. For your plantings, plants and packages, Cortex will automatically sync any activity from today. If you require synchronization of prior METRC activity, let us know the date from when you would like to sync your METRC data. </p>

        <p>
        Once your METRC API key and license number have been validated, it may take up to a couple of hours to bring your METRC data into Cortex for the first time. You will receive update emails throughout the process until your environment is ready for use.</p>
        <!-- <v-checkbox v-model="nometrc" label="I don't currently use METRC"></v-checkbox> -->
        <!-- :disabled="err_found && !error_state" -->
        <v-text-field  :label="!err_state ? 'State License ID for Facility' : 'Please correct State License ID for Facility'" v-model="license" outlined />
        <v-text-field  v-if="!nometrc" :label="!err_metrc ? 'METRC API Key' : 'Please correct METRC API Key'" v-model="metrc" outlined />
        <v-select label="State" :items="states" v-model="state" outlined />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="incomplete()" color="primary darken-1" text @click.native="agree()">{{options.ok ? options.ok : 'Yes'}}</v-btn>
        <v-btn color="grey" text @click.native="cancel()">{{options.cancel ? options.cancel : 'Cancel'}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axiosInstances from '@/../../coreui/server/axiosInstances.js'
import { sync } from "vuex-pathify"
export default {
  props: ['state_license', 'metrc_key', 'error_state', 'error_metrc'],
  data () {
    return {
      nometrc: false,
      metrc: null,
      license: null,
      err_state: false,
      err_metrc: false,
      err_found: false,
      state: '',
      states: ['CA','AK', 'DC','CO', 'LA', 'ME', 'MA', 'MD', 'MI', 'MO', 'MT', 'NV', 'OH', 'OK', 'OR', 'WV'],
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'primary',
        width: 290
      }
    }
  },
  computed : {
    origLoggedinUser: sync("login/origLoggedinUser"),
    errorPresent () {
      if (this.err_state || this.err_metrc) return true
      return false
    },
  },
  watch: {
    state_license (val) {
      this.license = val
    },
    metrc_key (val) {
      this.metrc = val
    },
    error_state (val) {
      this.err_state = val
    },
    error_metrc (val) {
      this.err_metrc = val
    }
  },
  methods: {
    error() {
      console.log('Error States: ', this.err_state, this.err_metrc)
      if (this.err_state || this.err_metrc) return true
      return false
    },
    incomplete() {
      if (this.state == null || this.state == '') return true
      if (this.license == null || this.license == '' ) return true
      if (!this.nometrc && (this.metrc == null || this.metrc== '')) return true
      return false
    },
    open (title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      console.log('Options: ', options)
      if (!options.width) options.wdith = 290
      this.options = Object.assign(this.options, options)
      if (this.options.metrc) this.metrc = this.options.metrc
      if (this.options.state) this.state = this.options.state
      if (this.options.err_metrc) this.err_metrc = this.options.err_metrc
      if (this.options.err_state) this.err_state = this.options.err_state
      if (this.options.state) this.state = this.options.state
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      console.log('posting creds: ')
      console.log(this.metrc, this.license, this.state, this.nometrc,
        this.origLoggedinUser.email)
      axiosInstances.origApiServer.post('/dt/v1/temp_credentials',
        {
          'metrc': this.metrc, 
          'license': this.license, 
          'state': this.state, 
          'nometrc': this.nometrc,
          'email': this.origLoggedinUser.email
        }
      )
      this.resolve(true)
      this.dialog = false
    },
    cancel () {
      this.resolve(false)
      this.dialog = false
    },
    error () {
      return this.metrc_key == null || this.state_license == null
    }
  }
}
</script>
<style>
  body {
    font-size: 1em !important;
    color: #000 !important;
    font-family: Arial !important;
  }
  
  h1 {
    color: teal;
    text-align: center;
    /* margin-left: 1em; */
  }
  
  ul.a {
    margin-left: 1em;
    margin-right: 1em;
    list-style-type: decimal;
    list-style-position: outside;
  }
  
  li {
    margin-top: 1em;
  }
  
  p {
    margin-left: 1em;
    margin-right: 1em;
  }
  
  p.e {
    font-style: italic;
  }
  .elist {
    margin-top: 3px;
  }
  </style>